import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { InvoiceEventsTable } from "components/tableComponents/invoiceEventsTable";
import VKButton from "components/vkButton";
import { usePaginationStore } from "utils/usePaginationStore";
import { LocalizeText } from "components/localizer";
import CommunityFilterInput from "components/searchFilterComponents/communityFilter";
import SearchFilterField from "components/searchFilterField";
import TopBar from "components/tableComponents/topBar";
import Banner from "components/banner";

const InvoicingView: FC = () => {
    const pagination = usePaginationStore("invoice-events", undefined, { page_size: 20, default_page_size: 20 });
    const navigate = useNavigate();

    return (
        <div className="contentWrapper">
            <Banner
                title="invoicing"
                subTitle="bannerInvoiceEvents"
                imageStyle={{ objectPosition: "60% 40%" }}
                image={`${process.env.PUBLIC_URL}/assets/images/arenaStaff/products.jpg`}
            />
            <TopBar
                searchField={
                    <SearchFilterField
                        pagination={pagination}
                        label={<LocalizeText tag="searchInvoiceOrders" />}
                        filterFields={<CommunityFilterInput pagination={pagination} />}
                    />
                }
                singleItem={
                    <VKButton
                        tag="appPurchases"
                        variant="outlined"
                        size="small"
                        onClick={() => navigate("/staff-invoicing/app-purchases")}
                    />
                }
            />

            <InvoiceEventsTable
                onClick={(invoiceEventId) => navigate(`/staff-invoicing/events/${invoiceEventId}`)}
                pagination={pagination}
            />

        </div>
    );
};

export default InvoicingView;
